// promise-based setTimeout() function.
// eslint-disable-next-line no-unused-vars
const delay = milliseconds => new Promise((resolve, reject) => setTimeout(resolve, milliseconds));

export default delay;



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/util/delay.js